<template>
  <div class="notifications-orders-date">
    <!-- eslint-disable vue/no-v-html -->
    <template v-if="deliveryDateShown">
      <span class="notifications-orders-date_blue">Дата доставки:</span>
      &nbsp;
      <span v-if="receivingDateTo">c&nbsp;{{ useIntervalDates(receivingDateFrom, receivingDateTo).replace('-', 'по') }}</span>
      <span v-else v-html="sanitize(getPickupDate(receivingDateFrom))" />
      <span>&nbsp;{{ deliveryTime ? `c ${deliveryTime.replace('-', ' до ')}` : '' }}</span>
    </template>
    <template v-else-if="status === STATUSES_TYPES.ready_to_issue">
      <span class="notifications-orders-date_blue">Срок хранения:</span>
      &nbsp;
      <span>до&nbsp;{{ useVerbalDate(receivingDateTo) }}&nbsp;включительно</span>
    </template>
    <template v-else-if="status === STATUSES_TYPES.at_pickup">
      <span class="notifications-orders-date_blue">Срок хранения:</span>
      &nbsp;
      <span>{{ pluralize(storagePeriod, ['день', 'дня', 'дней']) }}</span>
    </template>
    <template v-else-if="status !== STATUSES_TYPES.ready_to_issue && isPickup">
      <span class="notifications-orders-date_blue">Можно забрать:</span>
      &nbsp;
      <span v-if="receivingDateTo">c&nbsp;{{ useIntervalDates(receivingDateFrom, receivingDateTo).replace('-', 'по') }}</span>
      <span v-else v-html="sanitize(getPickupDate(receivingDateFrom))" />
    </template>
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script setup lang="ts">
import {
  computed,
} from 'vue';

import { useIntervalDates } from '@/composables/date/useIntervalDates';
import { useVerbalDate } from '@/composables/date/useVerbalDate';
import { DELIVERY_TYPES } from '@/constants/delivery';
import { isToday } from '@/utils/date/is-today';
import { isTomorrow } from '@/utils/date/is-tomorrow';
import { pluralize } from '@/utils/helpers/string-utils';
import { STATUSES_TYPES } from '@/utils/order-status';
import { sanitize } from '@/utils/sanitize';

interface IProps {
  status: string,
  receivingMethod: string,
  receivingDateFrom: string | null,
  receivingDateTo: string | null,
  storagePeriod: string | null,
  deliveryTime: string | null,
}

const props = withDefaults(defineProps<IProps>(), {
  receivingDateFrom: null,
  receivingDateTo: null,
  storagePeriod: null,
  deliveryTime: null,
});

const isDelivery = computed<boolean>(() => props.receivingMethod === DELIVERY_TYPES.delivery);
const isPickup = computed<boolean>(() => props.receivingMethod === DELIVERY_TYPES.store);
const deliveryDateShown = computed<boolean>(() => isDelivery.value
  || (props.receivingMethod !== DELIVERY_TYPES.store
  && props.status !== STATUSES_TYPES.at_pickup));

const getPickupDate = (date: string) => {
  const receivingDate = new Date(date);

  if (isToday(receivingDate) || isTomorrow(receivingDate) || isDelivery.value) {
    return useVerbalDate(date);
  }

  return `c&nbsp;${useVerbalDate(date)}`;
};

</script>

<style lang="scss">
.notifications-orders-date {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: #333;

  & &_blue {
    color: #1a82cb;
  }
}
</style>
